import { format, formatDistance, differenceInMonths, parseISO, differenceInMinutes, isValid } from 'date-fns';

interface FormatDateOptions {
  greaterThanPrefix?: string;
  lessThanPrefix?: string;
}

export function formatDate(
  date: Date,
  { greaterThanPrefix, lessThanPrefix }: FormatDateOptions = {}
): string {
  const isGreaterThanOneMonth = differenceInMonths(new Date(), date) >= 1;

  if (isGreaterThanOneMonth) {
    if (greaterThanPrefix) return format(date, `'${greaterThanPrefix}' do 'of' MMM',' yyyy`);
    return format(date, "do 'of' MMM',' yyyy");
  } else {
    if (lessThanPrefix) return `${lessThanPrefix} ${formatDistance(date, new Date())} ago`;
    return `${formatDistance(date, new Date())} ago`;
  }
}

export function createUSLocaleDateString(date: string): string {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: '2-digit' });
}

export function createDateStringFromEpoch(date: number): string {
  const epochConversionMultiplier = 1000;
  const d = new Date(date * epochConversionMultiplier);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: '2-digit' });
}

// This is to add a leading zero to the month and year if they are single digits
export function createTwoDigitMonthYearString(date: string): string {
  if (date.length === 1) {
    return `0${date}`;
  } else {
    return date;
  }
}

export const isWithinLast10Minutes = (serverTimestamp?: string): boolean => {
  if (!serverTimestamp) return false;
  // Parse the timestamp string to a Date object
  const parsedDate = parseISO(serverTimestamp);
  // Check if parsedDate is valid
  if (!isValid(parsedDate)) {
    return false; // Return false if the date is invalid
  }
  // Get the current time
  const now = new Date();
  // Calculate the difference in minutes between now and the parsed date
  const diffInMinutes = differenceInMinutes(now, parsedDate);
  // Check if the difference is within the last 10 minutes
  return diffInMinutes <= 10;
};
